import React, { useCallback, useMemo } from 'react';
import {
  HiddenContent,
  SideNavLinkInnerWrapper,
  SideNavLinkOuterWrapper,
  SideNavLinkTitleWrapper,
  SvgWrapper,
} from './styles';
import { SvgIcon } from 'src/commons/components/SvgIcon/SvgIcon';
import { useConsolidatedNavContext } from 'src/providers/ConsolidatedNavContextProvider';
import { NavMetricPublisher } from 'src/commons/utils/metrics';
import { renderFlag } from 'src/commons/utils/renderFlag';
import { getSideNavLinkTaktId } from 'src/commons/utils/logWithTakt';

interface SideNavLinkProps {
  id: string;
}

const SideNavLink: React.VFC<SideNavLinkProps> = ({ id }) => {
  const { isNavOpen, selectedNavItemId, toolbarItems } =
    useConsolidatedNavContext();

  const isSelected = useMemo(
    () => selectedNavItemId === id,
    [selectedNavItemId],
  );
  const toolbarItem = useMemo(
    () => toolbarItems.find((toolbarItem) => toolbarItem.id === id),
    [toolbarItems],
  );

  const onClickHandler = useCallback(() => {
    NavMetricPublisher.publishCounterMonitor(`toolbarItemClicked-${id}`, 1);
  }, [id]);

  if (!toolbarItem) {
    return null;
  }

  const { link, id: linkId } = toolbarItem.sidebarGroups[0].links[0];
  const title = link.label;
  const url = link.url;

  return (
    <SideNavLinkOuterWrapper isSelected={isSelected}>
      <SideNavLinkInnerWrapper
        isNavOpen={isNavOpen}
        isSelected={isSelected}
        href={url}
        data-takt-id={getSideNavLinkTaktId(linkId)}
        data-ccx-e2e-id={linkId}
        aria-label={title}
        onClick={onClickHandler}
        {...(isSelected && { ariaCurrent: 'page' })}
      >
        <SvgWrapper
          isSelected={isSelected}
          data-ccx-e2e-id={id}
          alignItems="center"
          justifyContent="center"
        >
          <SvgIcon
            iconPath={toolbarItem.iconPath}
            ariaLabel={title}
            isSelected={isSelected}
          />
        </SvgWrapper>
        {isNavOpen && (
          <HiddenContent>
            <SideNavLinkTitleWrapper>
              {title}
              {renderFlag(toolbarItem.sidebarGroups[0].links[0])}
            </SideNavLinkTitleWrapper>
          </HiddenContent>
        )}
      </SideNavLinkInnerWrapper>
    </SideNavLinkOuterWrapper>
  );
};

export default SideNavLink;
